// extracted by mini-css-extract-plugin
export default {"widget":"CalendarWidget_widget__s1Agc","widget__header":"CalendarWidget_widget__header__q31te"};